import { render, staticRenderFns } from "./ProspectsList.vue?vue&type=template&id=fdf20152&scoped=true"
import script from "./ProspectsList.vue?vue&type=script&lang=ts"
export * from "./ProspectsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf20152",
  null
  
)

export default component.exports